import { useEffect, useState } from "react";

import { isRestaurantOpen } from "../utils/openHours";

export function useOpenStatus(): boolean {
  const [isOpen, setIsOpen] = useState(() => isRestaurantOpen());

  useEffect(() => {
    const updateStatus = () => setIsOpen(isRestaurantOpen());
    const intervalId = window.setInterval(updateStatus, 60_000);

    document.addEventListener("visibilitychange", updateStatus);

    return () => {
      window.clearInterval(intervalId);
      document.removeEventListener("visibilitychange", updateStatus);
    };
  }, []);

  return isOpen;
}
